// Allow-list of Webble-Cast instances this deployment of the player is
// authorized to serve. The player only ever talks to instances listed here -
// any other instance UUID in the URL is rejected before anything is mounted.
//
// TODO: replace with the real instance UUID(s) and base URL(s) for this
// deployment.
const ALLOWED_INSTANCES = {
  '56aea998-b8b4-4b82-9db0-d360638e8285': 'https://staging.webble-cast.com',
  '4d0e7b5a-3190-443c-b6c2-f3f4da39f93c': 'https://app.webble-cast.com',
  '9f9c8d70-04e5-48c7-bfe0-90b05d2b4c2c': 'https://wef.webble-cast.com',
};

export function resolveInstanceUrl(instanceUuid) {
  return ALLOWED_INSTANCES[instanceUuid] ?? null;
}
